export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7731.358ba087.jpg";